var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveadvisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.639 37.1425C112.639 20.0356 98.7715 6.16797 81.6677 6.16797C71.2843 6.16797 62.1219 11.2938 56.5001 19.1284C50.8784 11.2938 41.7159 6.16797 31.3356 6.16797C14.2287 6.16797 0.361084 20.0324 0.361084 37.1425C0.361084 39.5658 0.668695 41.9136 1.19603 44.1768C5.49631 70.8981 35.2059 99.0885 56.5001 106.829C77.7912 99.0885 107.504 70.8981 111.798 44.1799C112.332 41.9168 112.639 39.5689 112.639 37.1425Z",
    fill: "#DD2E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveadvisor);
export default __webpack_public_path__ + "static/media/loveadvisor.5dc1aecb46d6b428e4c46307270b5bbb.svg";
export { ForwardRef as ReactComponent };